export default __webpack_public_path__ + "static/media/yale.29881a50.png";